<template>
  <div>
    <!--      <van-index-bar highlight-color="green" @select="anchorCh">
        <template v-for="(item, index) in list">
          <van-cell  :title="item.name" @click="ellClick(item)"/>
        </template>

      </van-index-bar>-->
    <!-- <div>
      <div>权限使用说明</div>
      <div>1、申请定位权限一边您输入地址和匹配最合适的司机</div>
    </div> -->
    <van-search v-model="value" shape="round" placeholder="请输入搜索关键词" @input="onSearch">
      <!-- <template #left>
          <div @click="back">
            <van-icon name="arrow-left" />
          </div>
        </template> -->
    </van-search>
    <van-index-bar highlight-color="green" @select="anchorCh">
      <template v-for="(item, index) in filteredList">
        <van-index-anchor :index="item.index">{{ item.index }}</van-index-anchor>
        <van-cell v-for="(res, idx) in item.list" :key="idx+item.index" :title="res.name" @click="ellClick(res)" />
      </template>
    </van-index-bar>
  </div>
</template>
<script>
import { MapUtil } from "@/api/app.js";
import minxins from "../minxins";
let pinyin = require('js-pinyin')
pinyin.setOptions({checkPolyphone:false,charCase:0})
export default {
    props:{
        title:{
            type:String
        }
    },
    mixins: [minxins],
    data(){
        return {
          value: "",
          citylists:''
        }
    },
  computed: {
    filteredList() {
      if (!this.value) {
        return this.citylists;
      }
      const keyword = this.value.toLowerCase();
      return this.citylists
        .map((group) => ({
          pinyinKey: group.pinyinKey,
          list: group.list.filter((city) =>
            city.name.toLowerCase().includes(keyword)
          ),
        }))
        .filter((group) => group.list.length > 0);
    },
  },
    async mounted(){
      const citys =JSON.parse(localStorage.getItem('citys'));
      console.log('====',citys);
      if (citys) {
        this.citylists = citys;
        return
      }
      this.queryComFun();
      // 使用统一的权限检查方法
      const hasPermission = await MapUtil.checkAndRequestLocationPermission();
      if (!hasPermission) {
        console.log('用户未授予定位权限');
        return;
      }
      this.getLocation()
    },
    methods: {
      anchorCh(e){
        console.log(e);
      },
      ellClick(e){
        this.$emit('childEvent',e)
        console.log(e);
      },
      onSearch(val) {
        console.log(val);
      },
      
    },

}
</script>
<style lang="less" scoped>
.globalHeader{
    width: 100%;
    height:40px;
    display: flex;
    justify-content:space-between;
    align-items:center;
    padding: 0 10px;
    box-sizing: border-box;
    position:fixed;
    left: 0;
    top: 0;
    z-index: 10;
    background-image: linear-gradient(90deg, #FF9F22, #FFB600);
    img{
      width:19px;
      height:22px;
      transform:rotate(180deg)
    }
    p{
      color:#fff;
      font-size: 0.9rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/regionList.vue